import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CONTACT } from "@/lib/content";

const ITEMS = [
  { icon: Phone, label: "Call or Text", value: CONTACT.phone, href: CONTACT.phoneHref },
  { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
  { icon: MapPin, label: "Service Area", value: CONTACT.area },
  { icon: Clock, label: "Hours", value: CONTACT.hours },
];

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="py-20 md:py-28 bg-[#F8FAFC] border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-12">
          <div className="label-caps mb-4">Get In Touch</div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1A2A5E]">
            Proudly serving Kelowna & the Okanagan.
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((it) => {
            const Card = it.href ? "a" : "div";
            return (
              <Card
                key={it.label}
                href={it.href}
                data-testid={`contact-${it.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="bg-white border border-[#E2E8F0] rounded-sm p-6 hover:shadow-lg transition-shadow block"
              >
                <div className="w-11 h-11 bg-[#EEF2FB] text-[#2B4BB8] rounded-sm flex items-center justify-center mb-4">
                  <it.icon className="w-5 h-5" />
                </div>
                <div className="text-xs font-bold uppercase tracking-widest text-[#94A3B8]">{it.label}</div>
                <div className="mt-1 font-semibold text-[#0F172A] text-sm leading-relaxed">{it.value}</div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
